export default function FilterPresetsBar({
  presets = [],
  activeQuery = '',
  onApply,
  onManage,
  loading = false,
}) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="text-[10px] font-medium uppercase tracking-wide text-slate-500 dark:text-slate-400">
        Пресеты
      </span>
      {loading && presets.length === 0 ? (
        <span className="text-[11px] text-slate-400">…</span>
      ) : null}
      {presets.map((preset) => {
        const isActive = normalizeQuery(preset.query) === normalizeQuery(activeQuery);
        return (
          <button
            key={preset.id}
            type="button"
            title={preset.name}
            onClick={() => onApply(preset)}
            className={
              isActive
                ? 'max-w-[10rem] truncate rounded-full border border-emerald-500/50 bg-emerald-500/15 px-2 py-0.5 text-[11px] font-medium text-emerald-800 dark:text-emerald-200'
                : 'max-w-[10rem] truncate rounded-full border border-slate-300 bg-slate-50 px-2 py-0.5 text-[11px] text-slate-700 hover:border-slate-400 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:border-slate-500'
            }
          >
            {preset.name}
          </button>
        );
      })}
      <button
        type="button"
        onClick={onManage}
        className="rounded-md border border-slate-300 px-2 py-0.5 text-[11px] font-medium text-slate-700 hover:border-slate-400 dark:border-slate-700 dark:text-slate-300 dark:hover:border-slate-500"
      >
        Управление
      </button>
    </div>
  );
}

function normalizeQuery(value) {
  const raw = String(value || '').trim();
  return raw.startsWith('?') ? raw.slice(1) : raw;
}
